import type { VmsTableSearch } from "@/routes/admin/_menu/_dual/virtual_machines.lazy.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/_menu/_dual/virtual_machines")({
    validateSearch: (params): VmsTableSearch => {
        return params as VmsTableSearch;
    },
});
